import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getReport } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import ReactAutocomplete from "react-autocomplete";
import { aclUtil } from "../../util";
import Pagination from "react-paginating";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired,
};
let cityItems = [];
let isLoading = "false",
  csvData = [];

class DealBuyer extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      menuKey: "DEALBUYER_REPORT",
      path: ["Home", "Deal Buyer Report"],
      links: ["home", "report/dealbuyer"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      limit: 10,
      pageCount: 0,
      csvData: "",
      reportData: "",
      historyPopup: false,
      offerIDs: "",
      dealType: "",
      merchantIDs: "",
      catID: "",
      merchantTypeID: "",
      downloadcsvData: [],
      downloadcsvData1: false,
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    //this.downloadCsv = this.downloadCsv.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = (date) => {
   
    if (date instanceof Date && !isNaN(date)) {
         this.setState({
          startDate: date,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(date  === null)
       {
        this.setState({
          startDate: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
        dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };
  // onChangeStartDateRange = date => this.setState({ startDateRange: date });

  onChangeStartDateRange = date => {
    
   
    if (date && date[0] instanceof Date && !isNaN(date[0])) {

         this.setState({
          startDateRange: date,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(date  === null)
       {
        this.setState({
          startDateRange: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
        dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };
  changeDatePicker = (status) => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format("YYYY-MM-DD"),
          endDate: moment(dateRange[1]).format("YYYY-MM-DD"),
          offerIDs: this.state.offerIDs,
          dealType: this.state.dealType,
          merchantIDs: this.state.merchantIDs,
          page: 1,
          limit: this.state.limit,
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
          catID: this.state.catID,
          offerIDs: this.state.offerIDs,
          dealType: this.state.dealType,
          merchantIDs: this.state.merchantIDs,
          page: 1,
          limit: this.state.limit,
        };
      }

      this.props.getReport(formData, "voucher/deal-buyer-report-paginate");
    }
  }

  downloadCsv = (e) => {
    isLoading = "true";
    const err = this.validate();
    let formData;

    //if (!err) {
    if (this.state.range == true) {
      let dateRange = this.state.startDateRange;
      formData = {
        startDate: moment(dateRange[0]).format("YYYY-MM-DD"),
        endDate: moment(dateRange[1]).format("YYYY-MM-DD"),
        offerIDs: this.state.offerIDs,
        dealType: this.state.dealType,
        merchantIDs: this.state.merchantIDs,
      };
    } else {
      formData = {
        startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
        catID: this.state.catID,
        offerIDs: this.state.offerIDs,
        dealType: this.state.dealType,
        merchantIDs: this.state.merchantIDs,
      };
    }

    this.props.getReport(formData, "voucher/deal-buyer-report");

    // }
  };
  Clear = () => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      if (siteData.combine_products == "disable") {
        this.setState({ dealType: "offer" });
        this.props.getReport(
          {
            startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
            dealType: "offer",
            page: this.state.currentPage,
            limit: this.state.limit,
          },
          "voucher/deal-buyer-report-paginate"
        );
      } else {
        this.props.getReport(
          {
            startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
            page: this.state.currentPage,
            limit: this.state.limit,
          },
          "voucher/deal-buyer-report-paginate"
        );
      }
    }
  }

  handlePageChange = (page) => {
    isLoading = "true";
    this.setState({
      currentPage: page,
    });

    {
      const err = this.validate();
      let formData;

      if (!err) {
        if (this.state.range == true) {
          let dateRange = this.state.startDateRange;
          formData = {
            startDate: moment(dateRange[0]).format("YYYY-MM-DD"),
            endDate: moment(dateRange[1]).format("YYYY-MM-DD"),
            offerIDs: this.state.offerIDs,
            dealType: this.state.dealType,
            merchantIDs: this.state.merchantIDs,
            page: page,
            limit: this.state.limit,
          };
        } else {
          formData = {
            startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
            catID: this.state.catID,
            offerIDs: this.state.offerIDs,
            dealType: this.state.dealType,
            merchantIDs: this.state.merchantIDs,
            page: page,
            limit: this.state.limit,
          };
        }

        this.props.getReport(formData, "voucher/deal-buyer-report-paginate");
      }
    }
  };
  componentWillReceiveProps(nextProps) {
    if (!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)) {
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        if (nextProps.reportData.message == "Data not available") {
          if (nextProps.reportData.type == "paginate") {
            this.setState({ reportData: nextProps.reportData });
            this.setState({ totalRecords: 0 });
          } else {
            this.handleExport(nextProps.reportData.data);
            this.setState({ downloadcsvData: nextProps.reportData.data });
          }
        } else {
          if (nextProps.reportData.type == "paginate") {
            const setPageCount =
              nextProps.reportData.data.total /
              nextProps.reportData.data.per_page;

            this.setState({ reportData: nextProps.reportData.data });
            this.setState({ totalRecords: nextProps.reportData.data.total });
            this.setState({ pageCount: setPageCount });
            this.setState({ perPage: nextProps.reportData.data.per_page });
          } else {
            this.handleExport(nextProps.reportData.data);
            this.setState({ downloadcsvData: nextProps.reportData.data });
          }
        }
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }
  }

  handleExport = (data) => {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
      dateRange = this.state.startDateRange;
    }
    let setDate =
      this.state.range == true && this.state.startDateRange
        ? moment(dateRange[0]).format("MM/DD/YYYY") +
          " - " +
          moment(dateRange[1]).format("MM/DD/YYYY")
        : moment(this.state.startDate).format("MM/DD/YYYY");
    csvData = [
      ["Data up to the date: " + setDate],
      [
        "Type",
        "Voucher Number",
        "OfferID",
        "Offer Name",
        "Merchant Name",
        "Buyer First Name",
        "Buyer Last Name",
        "Address Line 1",
        "Address Line 2",
        "City",
        "State",
        "ZIP",
        "Phone",
        "Voucher Location",
        "Voucher Status",
        "Voucher Redemption Date",
        "Timestamp",
        "SKU #",
        "Tracking Number",
        "Tracking Uploaded Date",
        "Shipping to Merchant",
        "Shipping to Admin",
        "Recipient First Name",
        "Recipient Last Name",
        "Shipping First Name",
        "Shipping Last Name",
        "Shipping Address",
        "Shipping City",
        "Shipping State",
        "Shipping Zip",
        "Gift Recipient Name",
        "Gift Recipient Address",
        "Gift Recipient City",
        "Gift Recipient State",
        "Gift Recipient Zip",
        "Attribute",
      ],
    ];

    {
      data &&
        data.map((buyer, index) =>
          csvData.push([
            buyer.proposal_type == "10"
              ? "Product"
              : buyer.proposal_type == "11"
              ? "Auction"
              : "Offer",
            buyer.voucherNumber,
            buyer.dealID,
            buyer.dealText,
            buyer.merchantName,
            buyer.firstName,
            buyer.lastName,
            buyer.recipient_address1,
            buyer.recipient_address2,
            buyer.recipient_city,
            buyer.recipient_state,
            buyer.recipient_zip,
            buyer.recipient_phone,
            buyer.voucher_location,
            buyer.status,
            buyer.redeemed_at,
            buyer.order_date,
            buyer.skuCode,
            buyer.trackingNumber,
            buyer.trackingUploadedAt,
            buyer.shipping_to_merchant,
            buyer.shipping_to_admin,
            buyer.recipient_first_name,
            buyer.recipient_last_name,
            JSON.parse(buyer.shipping_address).first_name,
            JSON.parse(buyer.shipping_address).last_name,
            (JSON.parse(buyer.shipping_address).line_1 !== null
              ? JSON.parse(buyer.shipping_address).line_1
              : "") +
              (JSON.parse(buyer.shipping_address).line_2 !== null
                ? "," + JSON.parse(buyer.shipping_address).line_2
                : ""),
            JSON.parse(buyer.shipping_address).city,
            JSON.parse(buyer.shipping_address).state,
            JSON.parse(buyer.shipping_address).zip,
            buyer.recipientName ? buyer.recipientName : "",
            buyer.recipientAddress
              ? JSON.parse(buyer.recipientAddress).address
                ? JSON.parse(buyer.recipientAddress).address
                : (JSON.parse(buyer.recipientAddress).line_1
                    ? JSON.parse(buyer.recipientAddress).line_1
                    : "") +
                  (JSON.parse(buyer.recipientAddress).line_2
                    ? "," + JSON.parse(buyer.recipientAddress).line_2
                    : "")
              : "",
            buyer.recipientAddress
              ? JSON.parse(buyer.recipientAddress).city
                ? JSON.parse(buyer.recipientAddress).city
                : ""
              : "",
            buyer.recipientAddress
              ? JSON.parse(buyer.recipientAddress).state
                ? JSON.parse(buyer.recipientAddress).state
                : ""
              : "",
            buyer.recipientAddress
              ? JSON.parse(buyer.recipientAddress).zip
                ? JSON.parse(buyer.recipientAddress).zip
                : ""
              : "",
            this.attribute(buyer.attribute),
          ])
        );
    }

    this.setState({ csvData: csvData });
  };
  componentDidUpdate() {
    if (!isEmpty(this.state.downloadcsvData)) {
      document.getElementById("downloadcsvData").click();
      this.setState({ downloadcsvData: [] });
    }
  }
  attribute(attributes) {
    let attr = "";
    if (attributes && attributes != "" && attributes !== null) {
      return attributes
        .map((value, index) => {
          return Object.keys(value)
            .map(function (k, i) {
              return k + " : " + value[k];
            })
            .join(" :: ");
        })
        .join(" || ");
    }
    return "";
  }

  render() {
    let dateRange;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    if (this.state.range == true && this.state.startDateRange) {
      dateRange = this.state.startDateRange;
    }
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <CSVLink
          data={this.state.csvData}
          filename={"merchantpayoutpaid-report.csv"}
          className="btn btn-default"
          id="downloadcsvData"
        ></CSVLink>

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent
              path={this.state.path}
              links={this.state.links}
            />
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Deal Buyer Report</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : 
                  
                    (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                   )
                    }
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                    <ControlLabel>Deal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="dealType"
                      onChange={this.handleChange}
                      placeholder="select"
                      value={this.state.dealType}
                    >
                      <option value="">All</option>
                      <option value="offer">Offer</option>
                      <option value="products">Products</option>
                      <option value="auction">Auction</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>
                      Merchant IDs (separate by comma)
                    </ControlLabel>
                    <FormControl
                      type="text"
                      name="merchantIDs"
                      value={this.state.merchantIDs}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                    <ControlLabel>Deal IDs (separate by comma)</ControlLabel>
                    <FormControl
                      type="text"
                      name="offerIDs"
                      value={this.state.offerIDs}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  <Button
                    bsStyle="info"
                    onClick={(this.showLoader, this.downloadCsv)}
                    //onClick={this.downloadCsv}
                  >
                    CSV Export
                  </Button>

                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th colSpan="19">
                    Data up to the date:{" "}
                    {this.state.range == true && this.state.startDateRange
                      ? moment(dateRange[0]).format("MM/DD/YYYY") +
                        " - " +
                        moment(dateRange[1]).format("MM/DD/YYYY")
                      : moment(this.state.startDate).format("MM/DD/YYYY")}
                  </th>
                </tr>
                <tr>
                  <th>Type</th>
                  <th>Voucher Number</th>
                  <th>OfferID</th>
                  <th>Offer Name</th>
                  <th>Merchant Name</th>
                  <th>Buyer First Name</th>
                  <th>Buyer Last Name</th>
                  <th>Address Line 1</th>
                  <th>Address Line 2</th>
                  <th>City</th>
                  <th>State</th>
                  <th>ZIP Code</th>
                  <th>Phone</th>
                  <th>Voucher Location </th>
                  <th>Voucher Status </th>
                  <th>Voucher Redemption Date </th>
                  <th>Timestamp</th>
                  <th>SKU #</th>
                  <th>Tracking Number</th>
                  <th>Tracking Uploaded Date</th>
                  <th>Shipping to Merchant</th>
                  <th>Shipping to Admin</th>
                  <th>Recipient First Name</th>
                  <th>Recipient Last Name</th>
                  <th>Shipping First Name</th>
                  <th>Shipping Last Name</th>
                  <th>Shipping Address</th>
                  <th>Shipping City</th>
                  <th>Shipping State</th>
                  <th>Shipping Zip</th>
                  <th>Gift Recipient Name</th>
                  <th>Gift Recipient Address</th>
                  <th>Gift Recipient City</th>
                  <th>Gift Recipient State</th>
                  <th>Gift Recipient Zip</th>
                  <th>Attribute</th>
                </tr>
              </thead>
              <tbody>
                {this.state.reportData ? (
                  this.state.reportData.data.map((buyer1, index) => (
                    <tr key={Math.random() + index}>
                      <td>
                        {buyer1.proposal_type == "10"
                          ? "Product"
                          : buyer1.proposal_type == "11"
                          ? "Auction"
                          : "Offer"}
                      </td>
                      <td>{buyer1.voucherNumber}</td>
                      <td>{buyer1.dealID}</td>
                      <td>{buyer1.dealText}</td>
                      <td>{buyer1.merchantName}</td>
                      <td>{buyer1.firstName}</td>
                      <td>{buyer1.lastName}</td>
                      <td>{buyer1.recipient_address1}</td>
                      <td>{buyer1.recipient_address2}</td>
                      <td>{buyer1.recipient_city}</td>
                      <td>{buyer1.recipient_state}</td>
                      <td>{buyer1.recipient_zip}</td>
                      <td>{buyer1.recipient_phone}</td>
                      <td>{buyer1.voucher_location}</td>
                      <td>{buyer1.status}</td>
                      <td>{buyer1.redeemed_at}</td>
                      <td>{buyer1.order_date}</td>
                      <td>{buyer1.skuCode}</td>
                      <td>{buyer1.trackingNumber}</td>
                      <td>{buyer1.trackingUploadedAt}</td>
                      <td>{buyer1.shipping_to_merchant}</td>
                      <td>{buyer1.shipping_to_admin}</td>
                      <td>{buyer1.recipient_first_name}</td>
                      <td>{buyer1.recipient_last_name}</td>
                      <td>{JSON.parse(buyer1.shipping_address).first_name}</td>
                      <td>{JSON.parse(buyer1.shipping_address).last_name}</td>
                      <td>
                        {JSON.parse(buyer1.shipping_address).line_1}{" "}
                        {JSON.parse(buyer1.shipping_address).line_2 !== null
                          ? "," + JSON.parse(buyer1.shipping_address).line_2
                          : ""}
                      </td>
                      <td>{JSON.parse(buyer1.shipping_address).city}</td>
                      <td>{JSON.parse(buyer1.shipping_address).state}</td>
                      <td>{JSON.parse(buyer1.shipping_address).zip}</td>
                      <td>
                        {buyer1.recipientName ? buyer1.recipientName : ""}
                      </td>
                      <td>
                        {buyer1.recipientAddress
                          ? JSON.parse(buyer1.recipientAddress).address
                            ? JSON.parse(buyer1.recipientAddress).address
                            : (JSON.parse(buyer1.recipientAddress).line_1
                                ? JSON.parse(buyer1.recipientAddress).line_1
                                : "") +
                              (JSON.parse(buyer1.recipientAddress).line_2
                                ? "," +
                                  JSON.parse(buyer1.recipientAddress).line_2
                                : "")
                          : ""}
                      </td>
                      <td>
                        {buyer1.recipientAddress
                          ? JSON.parse(buyer1.recipientAddress).city
                            ? JSON.parse(buyer1.recipientAddress).city
                            : ""
                          : ""}
                      </td>
                      <td>
                        {buyer1.recipientAddress
                          ? JSON.parse(buyer1.recipientAddress).state
                            ? JSON.parse(buyer1.recipientAddress).state
                            : ""
                          : ""}
                      </td>
                      <td>
                        {buyer1.recipientAddress
                          ? JSON.parse(buyer1.recipientAddress).zip
                            ? JSON.parse(buyer1.recipientAddress).zip
                            : ""
                          : ""}
                      </td>
                      <td>{this.attribute(buyer1.attribute)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="19">Data Not Found</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="text-center">
              <Pagination
                total={totalRecords}
                limit={perPage}
                pageCount={5}
                currentPage={currentPage}
              >
                {({
                  pages,
                  currentPage,
                  hasNextPage,
                  hasPreviousPage,
                  previousPage,
                  nextPage,
                  totalPages,
                  getPageItemProps,
                }) => (
                  <div className="pagination">
                    <button
                      className="btn btn-default"
                      {...getPageItemProps({
                        pageValue: 1,
                        onPageChange: this.handlePageChange,
                      })}
                    >
                      First
                    </button>

                    {hasPreviousPage && (
                      <button
                        className="btn btn-default"
                        {...getPageItemProps({
                          pageValue: previousPage,
                          onPageChange: this.handlePageChange,
                        })}
                      >
                        {"<"}
                      </button>
                    )}

                    {pages.map((page) => {
                      let activePage = null;
                      if (currentPage === page) {
                        activePage = {
                          backgroundColor: "#ccc",
                          color: "#666",
                        };
                      }
                      return (
                        <button
                          className="btn btn-default"
                          key={page}
                          style={activePage}
                          {...getPageItemProps({
                            pageValue: page,
                            onPageChange: this.handlePageChange,
                          })}
                        >
                          {page}
                        </button>
                      );
                    })}

                    {hasNextPage && (
                      <button
                        className="btn btn-default"
                        {...getPageItemProps({
                          pageValue: nextPage,
                          onPageChange: this.handlePageChange,
                        })}
                      >
                        {">"}
                      </button>
                    )}

                    <button
                      className="btn btn-default"
                      {...getPageItemProps({
                        pageValue: totalPages,
                        onPageChange: this.handlePageChange,
                      })}
                    >
                      Last
                    </button>
                  </div>
                )}
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
  })
)(DealBuyer);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/DealBuyer.js